import clsx from 'clsx';
import { forwardRef } from 'react';

type NotificationButtonProps = {
  unreadCount: number;
  onClick: () => void;
  isOpen: boolean;
};

export default forwardRef<HTMLButtonElement, NotificationButtonProps>(function NotificationButton(
  { unreadCount, onClick, isOpen },
  ref
) {
  return (
    <button
      ref={ref}
      className="relative inline-flex h-10 w-14 cursor-pointer items-center justify-center rounded-[32px] border-0 bg-[#F4F4F4] px-4 py-2.5 outline-1 outline-[#E5E7EB]"
      onClick={onClick}
      aria-label="Notifications"
      aria-haspopup="menu"
      aria-expanded={isOpen}
    >
      <img src="/notifs.svg" alt="Notifications" className="h-4 w-4" />
      {unreadCount > 0 && (
        <div
          className={clsx(
            'absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full border-2 border-white bg-red-600 font-semibold text-white',
            unreadCount > 9 ? 'text-[10px]' : 'text-[11px]'
          )}
        >
          {unreadCount > 9 ? '9+' : unreadCount}
        </div>
      )}
    </button>
  );
});
